import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import ReactTooltip from 'react-tooltip'
import PropTypes from 'prop-types'
import Caption4 from '../typography/captions/Caption4'
import colors from '../../configuration/colors'

const large = css`
  height: 40px;
  width: 40px;
  min-width: 40px;
  font-size: 21px;
  font-weight: bold;
`

const small = css`
  height: 16px;
  width: 16px;
  min-width: 16px;
  font-size: 11.15px;
  font-weight: bold;
`

const GradeElementStyled = styled(Caption4)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: 21px;
  width: 21px;
  min-width: 21px;
  color: ${colors.dove};
  font-family: Roboto;
  letter-spacing: 0;
  text-align: center;
  border: ${props => props.large ? '1.5px' : '0.85px'} solid ${colors.dove};
  border-radius: 3px;

  ${props => props.large && large}
  ${props => props.small && small}
`

const GradeElement = ({ name, abbreviation, large, small, style }) => (
  <Fragment>
    <ReactTooltip
      id="gradeLevelNameTooltip"
      place="top"
      effect="solid"
      className="gradeLevelTooltip"
    />
    <GradeElementStyled
      data-tip={name}
      data-for="gradeLevelNameTooltip"
      large={large}
      small={small}
      style={style}
    >
      {abbreviation}
    </GradeElementStyled>
  </Fragment>
)

GradeElement.propTypes = {
  name: PropTypes.string.isRequired,
  abbreviation: PropTypes.string.isRequired,
  large: PropTypes.bool,
  small: PropTypes.bool,
  style: PropTypes.object
}

export default GradeElement



// WEBPACK FOOTER //
// ./src/components/mini/GradeElement.js